import { render, staticRenderFns } from "./ClientsCreate.vue?vue&type=template&id=2a456056&scoped=true"
import script from "./ClientsCreate.vue?vue&type=script&lang=js"
export * from "./ClientsCreate.vue?vue&type=script&lang=js"
import style0 from "./ClientsCreate.vue?vue&type=style&index=0&id=2a456056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a456056",
  null
  
)

export default component.exports